export const SET_SUPPLIER = 'SET_SUPPLIER';
